import framework from '@/enums/enum-framework'

const enumsName = 'planScoreType'

const enums = [
  {
    value: 'GPA',
    label: 'GPA分数'
  },
  {
    value: 'TOFEL',
    label: '托福分数'
  },
  {
    value: 'IELTS',
    label: '雅思分数'
  },
  {
    value: 'GRE',
    label: 'GRE分数'
  },
  {
    value: 'GMAT',
    label: 'GMAT分数'
  },
  {
    value: 'GRE_SUB',
    label: 'GRE Sub分数'
  },
  {
    value: 'LSAT',
    label: 'LSAT考试'
  }
]

const map = framework.convert2Map(enums)

const filter = framework.convert2Filter(map)

const obj = {}
obj[enumsName + 'Enum'] = enums
obj[enumsName + 'Map'] = map
obj[enumsName + 'Filter'] = filter

export default obj
